import { SearchOutlined, SyncOutlined } from '@ant-design/icons';
import { Space, Tooltip } from 'antd';
import Buttons from 'components/Global/Buttons';
import SearchComponent from 'components/Global/SearchComponent';
import styles from './index.module.scss';

type Props = {
	button: any;
	searchText: string;
	handleSearch: (value: string) => void;
	handleSearchApi: (value: string) => void;
	isLoading: any;
	fetchLeaveManagementData: any;
};

const LeaveManagementHeader = (props: Props) => {
	const {
		button,
		searchText,
		handleSearch,
		handleSearchApi,
		fetchLeaveManagementData,
		isLoading,
	} = props;

	return (
		<div className={styles['employee-header']}>
			<Space>
				<SearchComponent
					className={styles['employee-header-item']}
					placeHolder="Search by type or description..."
					prefixIcon={<SearchOutlined />}
					handleChange={handleSearch}
					handleChangeApi={handleSearchApi}
					value={searchText}
					size="large"
				/>
			</Space>

			<Space>
				<div className={styles['employee-header__buttons']}>
					<Tooltip title="Refresh all the Leave Type">
						<SyncOutlined
							style={{
								fontSize: '20px',
								cursor: isLoading ? 'not-allowed' : 'pointer',
								color: '#584495',
								transition: 'transform 0.3s',
								marginRight: '10px',
							}}
							onClick={
								!isLoading
									? fetchLeaveManagementData
									: undefined
							}
						/>
					</Tooltip>
					<Buttons buttons={button} />
				</div>
			</Space>
		</div>
	);
};

export default LeaveManagementHeader;
